import React, { useMemo, useState, useEffect } from 'react';
import { FlapHeader, WithLoadingComponent, ProgressLoader, IconBtn, Input, Badge, PaginatorContainer } from 'components';
import { TaskService } from "services/http";
import { TagFormTemplate } from 'components/pages/admin-page/tag-management/tag-form-template';
import utils, { CUSTOM_MESSAGES, INNER_CONTAINER_HEIGHT } from 'utils';
import { ConfirmPopup } from "primereact/confirmpopup";
import { useHistory } from 'react-router';

export const TagManagement = () => {

    const [refresh, setRefresh] = useState();
    const [displayTagForm, setDisplayTagForm] = useState(false);
    const [actionType, setActionType] = useState();
    const [payload, setPayload] = useState({});
    const [title, setTitle] = useState();
    const history = useHistory();
    const [searchValue, setSearchValue] = React.useState(new URLSearchParams(window.location.search).get("search"));
    const [tagsLength, setTagstLength] = React.useState();

    return (
        <>
            <FlapHeader
                primeary
                justify
                leftSide={<span className="pt-1">Tag management &nbsp; <Badge data={`${tagsLength ? `${tagsLength}+` : '0'}`} servirity="warning" /></span>}
                rightSide={
                    <div className="d-flex">
                        <Input
                            className="mr-2"
                            icon="bi bi-search"
                            placeholder="Search..."
                            value={searchValue}
                            onChange={(e) => { utils.pushURLSearchParams(history, "search", e.target.value); setSearchValue(e.target.value) }} />
                        <IconBtn
                            icon="bi bi-plus-circle"
                            className="my-1"
                            tooltip="Add new tag"
                            size="18px"
                            onClick={() => {
                                setPayload({});
                                setDisplayTagForm(true);
                                setActionType(1);
                                setTitle("Add new tag");
                            }} />
                    </div>
                } />
            <div className="scroll-container" style={{ height: INNER_CONTAINER_HEIGHT }}>
                <TagSetHoc
                    shouldRefresh={refresh}
                    revertTagsLength={(val) => setTagstLength(val)}
                    editAction={(tag) => {
                        setDisplayTagForm(true);
                        setActionType(0);
                        setPayload(tag);
                        setTitle("Edit tag")
                    }}
                />
            </div>
            <TagFormTemplate
                title={title}
                payload={payload}
                actionType={actionType}
                display={displayTagForm}
                hide={() => setDisplayTagForm(false)}
                callbackRefresh={() => setRefresh(new Date().getMilliseconds())} />
        </>
    );
}


const TagSetContainer = (props) => {
    const { data, editAction } = props;
    const [tags, setTags] = useState(data);
    const searchItem = new URLSearchParams(window.location.search).get("search");

    //ON SEARCH CALLBACK ACTION
    useEffect(() => {
        let tempData = searchItem ? data.filter(tag => tag.description.toUpperCase().includes(searchItem.toUpperCase())) : data;
        setTags(tempData);
        props.revertTagsLength(tempData.length);
    }, [searchItem]);

    return <PaginatorContainer
        className="m-4"
        style={{ display: "grid", gridTemplateColumns: "20% 20% 20% 20% 20%" }}>
        {
            tags.map((tag, index) => {
                return <TagItemTemplate
                    key={index} {...tag}
                    editAction={() => { editAction(tag) }}
                    deleteAction={(tagId) => setTags(tags.filter(tag => tag.tagId !== tagId))} />
            })
        }
    </PaginatorContainer>
}

//HIGH ORDER COMPONENT FOR FETCHING INTERVENTION TAGS
const TagSetHoc = (props) => {
    const { shouldRefresh } = props;
    const TagsHoc = useMemo(() => WithLoadingComponent(TagSetContainer, () => TaskService.getTags(), <div style={{ position: "relative", minHeight: "90vh" }}><ProgressLoader /></div>)(props), [shouldRefresh]);
    return <TagsHoc />
}

//TAG ITEM TEMPLATE COMPONENT
const TagItemTemplate = (props) => {
    const { tagId, description, color, editAction, deleteAction } = props;
    const [displayDeleteConfirm, setDisplayDeleteConfirm] = useState(false);

    //ON DELETE TAG ITEM ACTION
    const onDeleteTag = () => {
        TaskService.deleteInterventionTag({ tagId: tagId }).then(() => {
            deleteAction(tagId);
        }, error => {
            alert(error);
        });
    }

    return <div className="tag-item-template card shadow m-1 text-left w-70" title={description} >
        <div className="card-body p-3 d-flex justify-content-between" style={{ position: "relative" }}>
            <pre className="m-0" style={{ whiteSpace: "break-spaces" }} >
                <i className="bi bi-tag-fill" style={{ color: `#${color}`, fontSize: "17px" }} />&nbsp;
                <element>#{utils.shorthandString(description, Math.trunc(window.screen.width / 130))}</element>
            </pre>
            <div className="mt-1 d-flex" style={{ fontSize: "12px" }}>
                <IconBtn
                    className="bi bi-pencil mx-1"
                    onClick={editAction} />
                <IconBtn
                    id={tagId}
                    className="bi bi-trash"
                    onClick={() => setDisplayDeleteConfirm(true)} />
                <ConfirmPopup
                    target={document.getElementById(tagId)}
                    visible={displayDeleteConfirm}
                    onHide={() => setDisplayDeleteConfirm(false)}
                    message={CUSTOM_MESSAGES.DELETE_ITEM_CONFIRMATION_MESSAGE}
                    icon={"bi bi-question-circle"}
                    accept={onDeleteTag}
                    reject={() => setDisplayDeleteConfirm(false)} />
            </div>
        </div>
    </div>
}